import * as React from 'react';
import { IDataSideBar } from "./FocusEcole/interface"
import { IMessage } from '../store/messagerieSlice';

export const dataOnglet = [
  { id: 1, libelle: "Focus - Ecole" },
  { id: 2, libelle: "Prof - Expert" }
]


export const dataSideBar: IDataSideBar[] = [
  {
    id: 0,
    label: "Tout"
  },
  {
    id: 1,
    label: "Envoyés",
    status: 1
  },
  {
    id: 2,
    label: "Non envoyés",
    status: 0
  },
  {
    id: 3,
    label: "Archivés",
    status: 2
  }
]


export const arrayData: IMessage[] = [
  {
    appSelected:"FOCUS",
    codeEtab:"000000",
    messageId: 1,
    phone: "0544530114",
    messageTitle: "information",
    messageContent: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    messageArcived:1
  },
  {
    appSelected:"FOCUS",
    codeEtab:"000000",
    messageId: 2,
    phone: "0544530114",
    messageTitle: "information",
    messageContent: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    messageArcived:1
  },
  {
    appSelected:"FOCUS",
    codeEtab:"000000",
    messageId: 3,
    phone: "0544530114",
    messageTitle: "information",
    messageContent: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    messageArcived:0,
    sentAt:"2024-07-26 15:19:27",
  },
  {
    appSelected:"FOCUS",
    codeEtab:"000000",
    messageId: 4,
    phone: "0544530114",
    messageTitle: "information",
    messageContent: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    messageArcived:0,
    sentAt:"2024-07-27 11:19:27",
  },
  {
    appSelected:"FOCUS",
    codeEtab:"000000",
    messageId: 5,
    phone: "0544530114",
    messageTitle: "information",
    messageContent: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    messageArcived:0,
    sentAt:null
  }
];
